// Cartao salvo do cliente. Sem campo de numero completo nem CVV: guardar CVV e proibido
// pelo PCI DSS, e o `token` e onde entra o identificador do gateway quando houver um.

export enum CartaoBandeira {
  Desconhecida = 0,
  Visa = 10,
  Mastercard = 20,
  Elo = 30,
  Amex = 40,
  Hipercard = 50,
}

const BANDEIRA_NOME: { [b: number]: string } = {
  [CartaoBandeira.Visa]: 'Visa',
  [CartaoBandeira.Mastercard]: 'Mastercard',
  [CartaoBandeira.Elo]: 'Elo',
  [CartaoBandeira.Amex]: 'Amex',
  [CartaoBandeira.Hipercard]: 'Hipercard',
  [CartaoBandeira.Desconhecida]: 'Cartão',
};

export function cartaoBandeiraNome(bandeira: CartaoBandeira): string {
  return BANDEIRA_NOME[bandeira] || BANDEIRA_NOME[CartaoBandeira.Desconhecida];
}

export function cartaoDigitos(valor: string): string {
  return (valor || '').replace(/\D/g, '');
}

// Agrupa de quatro em quatro enquanto o cliente digita.
export function cartaoFormata(valor: string): string {
  const digitos = cartaoDigitos(valor).slice(0, 19);
  return digitos.replace(/(.{4})/g, '$1 ').trim();
}

// Bandeira pelo prefixo. E so para exibir - quem decide de verdade e o gateway.
export function cartaoBandeiraDetecta(numero: string): CartaoBandeira {
  const d = cartaoDigitos(numero);
  if (/^4/.test(d)) {
    return CartaoBandeira.Visa;
  }
  if (/^(5[1-5]|2[2-7])/.test(d)) {
    return CartaoBandeira.Mastercard;
  }
  if (/^3[47]/.test(d)) {
    return CartaoBandeira.Amex;
  }
  if (/^(4011|4312|4389|5041|5067|509|6277|6362|650|651|655)/.test(d)) {
    return CartaoBandeira.Elo;
  }
  if (/^(606282|3841)/.test(d)) {
    return CartaoBandeira.Hipercard;
  }
  return CartaoBandeira.Desconhecida;
}

// Luhn. Pega digito trocado e numero inventado antes de mandar para o gateway - nao
// prova que o cartao existe, so que o numero e bem formado.
export function cartaoNumeroValido(numero: string): boolean {
  const d = cartaoDigitos(numero);
  if (d.length < 13 || d.length > 19) {
    return false;
  }
  let soma = 0;
  let dobra = false;
  for (let i = d.length - 1; i >= 0; i--) {
    let n = parseInt(d[i], 10);
    if (dobra) {
      n *= 2;
      if (n > 9) {
        n -= 9;
      }
    }
    soma += n;
    dobra = !dobra;
  }
  return soma % 10 === 0;
}

// Validade 'MM/AA'. Vencido conta como invalido, e o mes corrente ainda vale.
export function cartaoValidadeValida(validade: string, hoje: Date = new Date()): boolean {
  const casa = /^(\d{2})\/(\d{2})$/.exec((validade || '').trim());
  if (!casa) {
    return false;
  }
  const mes = parseInt(casa[1], 10);
  const ano = 2000 + parseInt(casa[2], 10);
  if (mes < 1 || mes > 12) {
    return false;
  }
  const mesAtual = hoje.getMonth() + 1;
  const anoAtual = hoje.getFullYear();
  return ano > anoAtual || (ano === anoAtual && mes >= mesAtual);
}

export function cartaoValidadeFormata(valor: string): string {
  const d = (valor || '').replace(/\D/g, '').slice(0, 4);
  return d.length > 2 ? `${d.slice(0, 2)}/${d.slice(2)}` : d;
}

export class Cartao {
  id: string;
  apelido: string;
  bandeira: CartaoBandeira;
  // Somente os quatro ultimos. O numero completo nunca chega aqui.
  final: string;
  nome: string;
  validade: string;
  // Identificador do gateway. Vazio = cartao so identifica, nao cobra.
  token: string;

  descricao(): string {
    return `${cartaoBandeiraNome(this.bandeira)} •••• ${this.final}`;
  }
}
